import { Component, OnInit, ViewChild, OnChanges, OnDestroy } from '@angular/core';
import { UrlsService } from '../../../Shared/Services/urls.service';
import { SharedHttpClientService } from '../../../Shared/Services/shared-http-client.service';
import { APIURL } from '../../../Shared/Constant/API_Urls';
import { UserService } from '../../../Shared/Services/user.service';
import { EmitterService } from '../../../Shared/Services/emitter.service';
import { DatePipe } from '@angular/common';
import { BaseChartDirective } from 'ng2-charts';
import { Subscription } from 'rxjs';
import { ChartConfiguration } from 'chart.js';

@Component({
    selector: 'app-exceptioncount',
    imports: [BaseChartDirective],
    templateUrl: './exceptioncount.component.html',
    styleUrls: ['./exceptioncount.component.scss']
})


export class ExceptioncountComponent implements OnInit,OnChanges, OnDestroy{
  windowsize: any;
  currentHover = "Total";
  windowY: any;
  windowX: any;
  slidecount!: number;
  @ViewChild(BaseChartDirective) chart: BaseChartDirective | any;
  JsonData: any;
  Totalcount!: number;
  TotalcountIntial!:number;
  public date: any = [];
  public dateLabelsArray: any = [];
  private Fmarketabuse: any[] = [];
  private Fbest: any[] = [];
  private Ffront: any[] = [];
  private Fcat: any[] = [];
  private Ftotal: any[] = [];
  private Lmarketabuse: any[] = [];
  private Lbest: any[] = [];
  private Lfront: any[] = [];
  private Lcat: any[] = [];
  private Ltotal: any[] = [];
  private LclientData: any[] = [];
  private FclientData: any[] = [];
  private CAISClientData: any[] = [];
  private CAISFinraData: any[] = [];
  public tempdate: any;
  public subscription!: Subscription;
  private interval: number = 0;
  //variable intialization;
  public barChartOptions: any = {
    scaleShowVerticalLines: false,
    responsive: true,
    scaleShowValues: true,
    scaleValuePaddingX: 0,
    scaleValuePaddingY: 0,
    
    scales: {
      y: {
        //scaleLabel:{ display: true, labelString: 'Exception Count'},
        ticks: {
          beginAtZero: true,
          maxTicksLimit: 5,
          stepSize: 1,
          // Create Numberic notation labels
          callback: function (value: any, index: any, values: any) {
            
            if (value >= 1000 && value < 1000000) {
              value = value / 1000 + ' K';
            }
            if (value >= 1000000) {
              value = value / 1000000 + ' M';
            }
            return value;
          }
        }
      },
      x: {
        scrollbar: {
          enabled: true
        }
      }
    },
    plugins: {
      datalabels: { 
        anchor: 'end',
        align: 'top',
        padding: -6,
        formatter: (value: any) => {
          if (value >= 1000 && value < 1000000) {
            value = Math.floor(value / 1000) + 'K';
          }
          if (value >= 1000000) {
            value = Math.floor(value / 1000000) + 'M';
          }
          return value; 
        },
        color: 'black' 
      },
      legend: {
        display: true,
        position: 'top',
      },
      tooltips:  //  false,
      {
        enabled: true,
        backgroundColor: 'Black',
        textColor: 'black',
        opacity: 1
        
      }
    }
  };
  public barChartLabels: string[] = this.dateLabelsArray;
  public barChartType: any = "'bar'";
  public newcolor1: any[] = [
    '#ffc822',
    '#ffc822',
    '#ffc822',
    '#ffc822',
    '#ffc822',
  ];
  public newcolor2: any[] = [
    '#e84351',
    '#e84351',
    '#e84351',
    '#e84351',
    '#e84351',
  ];
  public chartColors: Array<any> = [
    { // first color
      backgroundColor: this.newcolor1,
      borderColor: 'rgba(225,10,24,0.2)',
      pointBackgroundColor: 'rgba(225,10,24,0.2)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(225,10,24,0.2)'
    },
    { // second color
      backgroundColor: this.newcolor2,
      borderColor: 'rgba(225,10,24,0.2)',
      pointBackgroundColor: 'rgba(225,10,24,0.2)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(225,10,24,0.2)'
    }];

  public chartData: any[] = [
    {
      label: "Exception First Run",
      data: [0, 0, 0, 0, 0, 0, 0],
      categoryPercentage: 0.8,
      barPercentage:0.5,
      backgroundColor: this.newcolor1

    },
    {
      label: "Exception Last Run",
      data: [0, 0, 0, 0, 0, 0, 0],
      categoryPercentage: 0.8,
      barPercentage:0.5,
      backgroundColor: this.newcolor2

    }
  ];
  public barChartData: ChartConfiguration<'bar'>['data'] = {
    labels: this.dateLabelsArray,
    datasets: this.chartData
  };
  private leftCounter: number = 0;
  private isRequestCompleted:boolean=true;

  constructor(
    private UrlsService: UrlsService,
    private datePipe: DatePipe,
    private UserService: UserService,
    private SharedHttpClientService: SharedHttpClientService,
    private EmitterService: EmitterService) {
  }

  getData() {
    if(this.isRequestCompleted){
      this.isRequestCompleted = false;
    this.SharedHttpClientService.get(
      this.UrlsService.setAPIURl3(
        APIURL.MD_ExceptionCount,
        this.UserService.getActiveMPID(),
        this.UserService.getDays() + this.interval,
        'TOTAL'))
      .subscribe((data) => {
      this.isRequestCompleted = true;
        let dataset:any = data;
        this.JsonData=dataset.Data;
        
        if (this.JsonData == null) {

          this.JsonData = [
            { reportDate: "No-Data", ffrontopen: 0, ffrontclose: 0, fbestopen: 0, fbestclose: 0,  fcatopen: 0, fcatclose: 0, fmarketopen: 0, fmarketclose: 0, ftotal: 0, lfrontopen: 0, lfrontclose: 0, lbestopen: 0, lbestclose: 0, lcatopen: 0, lcatclose: 0, lmarketopen: 0, lmarketclose: 0, fclientopen: 0, lclientopen: 0, caisclienttotal: 0, caisfinratotal: 0 },
            { reportDate: "No-Data", ffrontopen: 0, ffrontclose: 0, fbestopen: 0, fbestclose: 0, fcatopen: 0, fcatclose: 0, fmarketopen: 0, fmarketclose: 0, ftotal: 0, lfrontopen: 0, lfrontclose: 0, lbestopen: 0, lbestclose: 0, lcatopen: 0, lcatclose: 0, lmarketopen: 0, lmarketclose: 0, fclientopen: 0, lclientopen: 0, caisclienttotal: 0, caisfinratotal: 0 },
            { reportDate: "No-Data", ffrontopen: 0, ffrontclose: 0, fbestopen: 0, fbestclose: 0, fcatopen: 0, fcatclose: 0, fmarketopen: 0, fmarketclose: 0, ftotal: 0, lfrontopen: 0, lfrontclose: 0, lbestopen: 0, lbestclose: 0, lcatopen: 0, lcatclose: 0, lmarketopen: 0, lmarketclose: 0, fclientopen: 0, lclientopen: 0, caisclienttotal: 0, caisfinratotal: 0 },
            { reportDate: "No-Data", ffrontopen: 0, ffrontclose: 0, fbestopen: 0, fbestclose: 0, fcatopen: 0, fcatclose: 0, fmarketopen: 0, fmarketclose: 0, ftotal: 0, lfrontopen: 0, lfrontclose: 0, lbestopen: 0, lbestclose: 0, lcatopen: 0, lcatclose: 0, lmarketopen: 0, lmarketclose: 0, fclientopen: 0, lclientopen: 0, caisclienttotal: 0, caisfinratotal: 0 },
            { reportDate: "No-Data", ffrontopen: 0, ffrontclose: 0, fbestopen: 0, fbestclose: 0, fcatopen: 0, fcatclose: 0, fmarketopen: 0, fmarketclose: 0, ftotal: 0, lfrontopen: 0, lfrontclose: 0, lbestopen: 0, lbestclose: 0, lcatopen: 0, lcatclose: 0, lmarketopen: 0, lmarketclose: 0, fclientopen: 0, lclientopen: 0, caisclienttotal: 0, caisfinratotal: 0 },
            { reportDate: "No-Data", ffrontopen: 0, ffrontclose: 0, fbestopen: 0, fbestclose: 0, fcatopen: 0, fcatclose: 0, fmarketopen: 0, fmarketclose: 0, ftotal: 0, lfrontopen: 0, lfrontclose: 0, lbestopen: 0, lbestclose: 0, lcatopen: 0, lcatclose: 0, lmarketopen: 0, lmarketclose: 0, fclientopen: 0, lclientopen: 0, caisclienttotal: 0, caisfinratotal: 0 }
          ];
          this.Totalcount = Object.keys(this.JsonData).length;
          this.TotalcountIntial = this.Totalcount;
        }
        else {
         let previousTotal = this.Totalcount;
          this.Totalcount = Object.keys(this.JsonData).length;
          this.TotalcountIntial = this.Totalcount;
    
        this.slidecount = 0;
        if (this.Totalcount <= 5) {
          this.windowsize = 0;
          for (let i = 0, t = 0; i < this.Totalcount; i++ , t++) {
            this.dateLabelsArray.push(this.datePipe.transform(this.JsonData[i].reportDate, 'dd-MMM'));
            this.date.push(this.JsonData[i].reportDate);
            this.Ffront[t] = (this.JsonData[i].ffrontclose + this.JsonData[i].ffrontopen);
            this.Fbest[t] = (this.JsonData[i].fbestclose + this.JsonData[i].fbestopen);
            this.Fcat[t] = (this.JsonData[i].fcatclose + this.JsonData[i].fcatopen);
            this.Fmarketabuse[t] = (this.JsonData[i].fmarketopen + this.JsonData[i].fmarketclose);
            this.Ftotal[t] = this.JsonData[i].ftotal;           

            this.Lfront[t] = (this.JsonData[i].lfrontclose + this.JsonData[i].lfrontopen);
            this.Lbest[t] = (this.JsonData[i].lbestclose + this.JsonData[i].lbestopen);
            this.Lcat[t] = (this.JsonData[i].lcatclose + this.JsonData[i].lcatopen);
            this.Lmarketabuse[t] = (this.JsonData[i].lmarketopen + this.JsonData[i].lmarketclose);
            this.Ltotal[t] =this.JsonData[i].ltotal;
        
            this.FclientData[t] = (this.JsonData[i].fclientclose + this.JsonData[i].fclientopen);
            this.LclientData[t] = (this.JsonData[i].lclientclose + this.JsonData[i].lclientopen);

            this.CAISClientData[t] = (this.JsonData[i].caisclienttotal);
            this.CAISFinraData[t] = (this.JsonData[i].caisfinratotal);
          }
          if (this.currentHover === "Total") {
            this.Total();
          } if (this.currentHover == "Bestex") {
            this.BestException();
          } if (this.currentHover == "Frontrun") {
            this.FrontRunning();
          } if (this.currentHover == "MarketA") {
            this.MarketAbuse();
          } if (this.currentHover == "Cat") {
            this.CatException();
          } if (this.currentHover == "Client Data") {
            this.clientDataException();
          } if (this.currentHover == "CAIS") {
            this.caisDataException();
          }
          } else {
            this.windowsize = 5;
            if (this.leftCounter < 6) {
              this.windowY = this.Totalcount + this.slidecount;
              this.windowX = (this.windowY - this.windowsize);
            } else {
              this.windowX = this.windowX + (Object.keys(this.JsonData).length - previousTotal);
              this.windowY = this.windowX + 5;
            }
            this.sortData();
          }
        }
      });
    }
  }

  clickLeft() {
    this.slidecount = -1;
    this.leftCounter++;
   
    if((this.leftCounter%15!=0) && this.windowX!=10){
      this.windowY = this.windowY + this.slidecount;
      this.windowX = this.windowX-1;
      this.sortData();
    }     
  }

  clickRight() {
    this.slidecount = 1;  
    if (this.windowY <= this.TotalcountIntial && this.windowsize >= 5) {
      this.windowY = this.windowY + this.slidecount;
      this.windowX = (this.windowY - this.windowsize);
      this.Totalcount += 1;
      this.sortData();
    }
  }

  sortData() {
    if ((this.windowY < this.Totalcount || this.leftCounter == 0) && this.windowY > 0) {
      if((this.leftCounter != 0 && this.leftCounter%15 == 0) || this.windowX==10){
        this.interval += 30;
        this.leftCounter++;
        this.getData();
      }
      let length = this.date.length;
      this.date.splice(0, this.date.length);
      this.dateLabelsArray.splice(0, this.dateLabelsArray.length);
      this.Ftotal.splice(0, this.Ftotal.length);
      this.Ffront.splice(0, this.Ffront.length);
      this.Fbest.splice(0, this.Fbest.length);
      this.Fcat.splice(0, this.Fcat.length);
      this.Fmarketabuse.splice(0, this.Fmarketabuse.length);
      this.Ltotal.splice(0, this.Ltotal.length);
      this.Lfront.splice(0, this.Lfront.length);
      this.Lbest.splice(0, this.Lbest.length);
      this.Lcat.splice(0, this.Lcat.length);
      this.LclientData.splice(0, this.LclientData.length);
      this.FclientData.splice(0, this.FclientData.length);
      this.CAISClientData.splice(0, this.CAISClientData.length);
      this.CAISFinraData.splice(0, this.CAISFinraData.length);
      this.Lmarketabuse.splice(0, this.Lmarketabuse.length);

      for (let i = this.windowX, t = 0; i < this.windowY; i++ , t++) {
        if(this.JsonData[i] != undefined){
        this.dateLabelsArray.push(this.datePipe.transform(this.JsonData[i].reportDate, 'dd-MMM'));
        this.date.push(this.JsonData[i].reportDate);

        this.Ffront[t] = (this.JsonData[i].ffrontclose + this.JsonData[i].ffrontopen);
            this.Fbest[t] = (this.JsonData[i].fbestclose + this.JsonData[i].fbestopen);
            this.Fcat[t] = (this.JsonData[i].fcatclose + this.JsonData[i].fcatopen);
            this.Fmarketabuse[t] = (this.JsonData[i].fmarketopen + this.JsonData[i].fmarketclose);
            this.Ftotal[t] = this.JsonData[i].ftotal;

            this.Lfront[t] = (this.JsonData[i].lfrontclose + this.JsonData[i].lfrontopen);
            this.Lbest[t] = (this.JsonData[i].lbestclose + this.JsonData[i].lbestopen);
            this.Lcat[t] = (this.JsonData[i].lcatclose + this.JsonData[i].lcatopen);
            this.Lmarketabuse[t] = (this.JsonData[i].lmarketopen + this.JsonData[i].lmarketclose);
            this.Ltotal[t] =this.JsonData[i].ltotal;

            this.FclientData[t] = (this.JsonData[i].fclientclose + this.JsonData[i].fclientopen);
            this.LclientData[t] = (this.JsonData[i].lclientclose + this.JsonData[i].lclientopen);

            this.CAISClientData[t] = (this.JsonData[i].caisclienttotal);
            this.CAISFinraData[t] = (this.JsonData[i].caisfinratotal);
          }
      }
    } 

    if ((this.currentHover).toLocaleLowerCase() === ("Total").toLocaleLowerCase()) {
      this.Total();
    } else if ((this.currentHover).toLocaleLowerCase() === ("Best Ex").toLocaleLowerCase()) {
      this.BestException();
    } else if ((this.currentHover).toLocaleLowerCase() === ("Front running").toLocaleLowerCase()) {
      this.FrontRunning();
    } else if ((this.currentHover).toLocaleLowerCase() === ("Market Abuse").toLocaleLowerCase()) {
      this.MarketAbuse();
    } else if ((this.currentHover).toLocaleLowerCase() === ("CAT").toLocaleLowerCase()) {
      this.CatException();
    } else if ((this.currentHover).toLocaleLowerCase() === ("Client Data").toLocaleLowerCase()) {
      this.clientDataException();
    } else if ((this.currentHover).toLocaleLowerCase() === ("CAIS").toLocaleLowerCase()) {
      this.caisDataException();
    }
  }

  ngOnInit() {
    this.getData();
    this.subscription = this.EmitterService.reloadMainDashBoard.subscribe(value => {
      if (value) {
        this.getData();
      }
    });
  }

  ngAfterViewInit() {
    this.sortData();
  }

  ngOnChanges() {
     this.chart.chart.update();
  }


  reloadData($event: any) {
    // this.barChartLabels=this.date; 
    // if(this.currentHover!=$event){
    /* Catch User Action Log */
        this.UserService.logUserActivity("Applied Dashboard Transaction Count Filter", "Dashboard", {
          'Text1': this.UserService.userFirstName + ' Applied Dashboard Transaction Count Filter from Dashboard',
          'Text2': 'User Filter Parameters: ' + JSON.stringify({ optedtransactionCountCategory: $event, page: 'Dashboard' })
        });
    this.EmitterService.getOpenExceptionCount.emit({ Label: $event, Date: 'NULL' });
    this.currentHover = $event
    if ((this.currentHover).toLocaleLowerCase() === ("Total").toLocaleLowerCase()) {
      this.Total();
    } if ((this.currentHover).toLocaleLowerCase() === ("Best Ex").toLocaleLowerCase()) {
      this.BestException();
    } if ((this.currentHover).toLocaleLowerCase() === ("Front running").toLocaleLowerCase()) {
      this.FrontRunning();
    } if ((this.currentHover).toLocaleLowerCase() === ("Market Abuse").toLocaleLowerCase()) {
      this.MarketAbuse();
    } else if ((this.currentHover).toLocaleLowerCase() === ("CAT").toLocaleLowerCase()) {
      this.CatException();
    } else if ((this.currentHover).toLocaleLowerCase() === ("Client Data").toLocaleLowerCase()) {
      this.clientDataException();
    } else if ((this.currentHover).toLocaleLowerCase() === ("CAIS").toLocaleLowerCase()) {
      this.caisDataException();
    }
  }

  Total(): any {
    this.barChartData ={
      labels: this.dateLabelsArray,
      datasets: [
        {
          label: 'Total First Run ',
          data: this.Ftotal,
          backgroundColor: this.newcolor1,
          barPercentage: 0.5,
          categoryPercentage: 0.8,
        },
        {
          label: 'Total Last Run ',
          data: this.Ltotal,
          backgroundColor: this.newcolor2,
          barPercentage: 0.5, 
          categoryPercentage: 0.8
        }
      ],
    }
  }

  BestException(): any {
    this.barChartData ={
      labels: this.dateLabelsArray,
      datasets: [
        {
          label: 'Best First Run',
          data: this.Fbest,
          backgroundColor: this.newcolor1,
          barPercentage: 0.5,
          categoryPercentage: 0.8,
        }, {
          label: 'Best Last Run',
          data: this.Lbest,
          backgroundColor: this.newcolor2,
          barPercentage: 0.5,
          categoryPercentage: 0.8,
        }
      ],
    }
  }

  MarketAbuse(): any {
    this.barChartData ={
      labels: this.dateLabelsArray,
      datasets: [
        {
          label: 'Market Abuse First Run ',
          data: this.Fmarketabuse,
          backgroundColor: this.newcolor1,
          barPercentage: 0.5,
          categoryPercentage: 0.8,
        },
        {
          label: 'Market Abuse Last Run  ',
          data: this.Lmarketabuse,
          backgroundColor: this.newcolor2,
          barPercentage: 0.5,
          categoryPercentage: 0.8,
        }
      ],
    }
  }

  FrontRunning(): any {
    this.barChartData ={
      labels: this.dateLabelsArray,
      datasets: [
        {
          label: 'Front Running First Run',
          data: this.Ffront,
          backgroundColor: this.newcolor1,
          barPercentage: 0.5,
          categoryPercentage: 0.8,
        },
        {
          label: 'Front Running Last Run',
          data: this.Lfront,
          backgroundColor: this.newcolor2,
          barPercentage: 0.5,
          categoryPercentage: 0.8,
        }
      ],
    }
  }

  CatException(): any {
    this.barChartData ={
      labels: this.dateLabelsArray,
      datasets: [
        {
          label: 'Finra Exception First Run',
          data: this.Fcat,
          backgroundColor: this.newcolor1,
          barPercentage: 0.5,
          categoryPercentage: 0.8,
        },
        {
          label: 'Finra Exception Last Run',
          data: this.Lcat,
          backgroundColor: this.newcolor2,
          barPercentage: 0.5,
          categoryPercentage: 0.8,
        }
      ],
    }
    
    // throw new Error("Method Front Runnng ");
  }
  clientDataException() {
    this.barChartData ={
      labels: this.dateLabelsArray,
      datasets: [
        {
          label: 'Client Data First Run',
          data: this.FclientData,
          backgroundColor: this.newcolor1,
          barPercentage: 0.5,
          categoryPercentage: 0.8,
        },
        {
          label: 'Client Data Last Run',
          data: this.LclientData,
          backgroundColor: this.newcolor2,
          barPercentage: 0.5,
          categoryPercentage: 0.8,
        }
      ],
    }
  }
  caisDataException() {
    this.barChartData ={
      labels: this.dateLabelsArray,
      datasets: [
        {
          label: 'CAIS Client Data Exception',
          data: this.CAISClientData,
          backgroundColor: this.newcolor1,
          barPercentage: 0.5,
          categoryPercentage: 0.8,
        },
        {
          label: 'CAIS FINRA Exception',
          data: this.CAISFinraData,
          backgroundColor: this.newcolor2,
          barPercentage: 0.5,
          categoryPercentage: 0.8,
        }
      ],
    }
  }
  // events
  public chartClicked(e: any): void {
    let date: any = "NULL"
    let ChartElement;
    if (e.active.length > 0) {
      ChartElement = e.active[0]
      if (ChartElement) {
        date = this.date[ChartElement.index];
        e.active[0].element.options.backgroundColor = "green";
      }
      this.chart.chart?.update();
      this.EmitterService.getOpenExceptionCount.emit({ Label: this.currentHover, Date: date });
    }

  }

  public chartHovered(e: any): void {
    //this.EmitterService.getOpenExceptionCount.emit({Label:this.currentHover,Date:'Null'});
  }
  ngOnDestroy() {
    if(this.subscription)
    this.subscription.unsubscribe();
  }

}
